function injectBeacon() {
  !function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
}

class Beacon {
  get Beacon() {
    return window.Beacon
  }

  get data() {
    return document.getElementById("beacon-data")?.dataset
  }

  constructor() {
    if (!this.data) return
    if (this.initialized) return
    injectBeacon()
    this.Beacon("init", this.data.beaconId)
    this.Beacon("identify", JSON.parse(atob(this.data.beaconData)))
    this.Beacon("open")
    this.initialized = true
  }
}

new Beacon()
